export default __webpack_public_path__ + "static/media/luxottica.9966adeb.png";